// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
import * as React from "react";
import { cn } from "../../lib/utils";

const Progress = React.forwardRef(({ className, value = 0, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("relative h-3 w-full overflow-hidden rounded-full", className)}
    style={{ background: 'var(--white)' }}
    {...props}
  >
    <div
      className="h-full transition-all duration-300 rounded-full"
      style={{ 
        width: `${value}%`,
        background: 'linear-gradient(90deg, var(--blue) 0%, var(--blue-light) 100%)',
        boxShadow: '0 2px 8px rgba(50, 96, 225, 0.3)'
      }}
    />
  </div>
));
Progress.displayName = "Progress";

export { Progress };